import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * A custom element that keeps the "net weight" table cell in the product details
 * tabs in sync with the currently selected variant, since that section lives
 * outside the product-information section that normally re-renders on selection.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} value
 *
 * @extends Component<Refs>
 */
class ProductTabsNetWeight extends Component {
  requiredRefs = ['value'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {CustomEvent & { promise?: Promise<{ detail?: { resource?: { title?: string } } }> }} event
   */
  #handleProductSelect = (event) => {
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        const title = detail?.resource?.title;
        if (!title || title === 'Default Title') return;
        this.refs.value.textContent = title;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-tabs-net-weight] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-tabs-net-weight')) {
  customElements.define('product-tabs-net-weight', ProductTabsNetWeight);
}
